import { generateText, JSONContent } from '@tiptap/core';

import { logException } from 'approot/shared/debug';
import {
  getExtensions,
  isRichtextEmpty,
} from 'approot/shared/richtext/richtext.utils';
import { TITLE_RICHTEXT_SETTINGS } from 'approot/activity-builder/introduction/activity-builder-intro-title.constants';

export function getTextFromRichtext({
  richtext,
  sourceFile,
  contentId,
}: {
  richtext?: JSONContent | null;
  sourceFile: string;
  contentId?: number;
}) {
  try {
    return richtext && !isRichtextEmpty(richtext)
      ? generateText(richtext, getExtensions(TITLE_RICHTEXT_SETTINGS))
      : '';
  } catch {
    console.error('Tiptap richtext format invalid');
    if (contentId) {
      logException({
        sourceFile,
        message: `Tiptap richtext format invalid. ContentId: ${contentId}`,
      });
    }

    return '';
  }
}
